import React, { memo } from 'react'
import useCanEdit from '../../../../hooks/useCanEdit'
import cn from 'classnames'
import styles from './VacancyManagerTemplatesList.module.scss'

import { ReactComponent as EditIcon } from '../../../../assets/icons/edit.svg'
import CrossIcon from '../../../../UI/Icons/CrossIcon'
import { TrashIcon } from '../../../../UI/Icons/Icons'
import UseSmartTooltip from '../../../../hooks/useSmartTooltip'
import { removeUnderscoreAndCapitalize } from '../../../../helpers/vacancyTemplatesManager.helper'

const VacancyManagerTemplatesListItem = memo(
    ({
        data,
        onDeleteClick,
        onEditClick,
        isOnEdit = false,
    }) => {
        const isCanEdit = useCanEdit()
        const { id, name, description, salary_description, template_type, vacancy_type } = data

        return (
            <div
                className={cn(styles.template, {
                    [styles.template_inactive]: !isCanEdit,
                    [styles.template_active]: isOnEdit,
                })}
            >
                <p className={styles.topInfo}>
                    {vacancy_type} {removeUnderscoreAndCapitalize(template_type)}
                </p>

                <div className={styles.templateHeader}>
                    <UseSmartTooltip
                        tagType={'span'}
                        className={styles.templateName}
                        id={name ? `${name.split(' ').join('')}` : ''}
                        children={
                            <>
                                <b>Template name: </b>
                                {name}
                            </>
                        }
                        amount_of_line={1}
                    />

                    <div className={styles.controls}>
                        <button data-tip="delete" data-for="default" onClick={() => onDeleteClick(id)}>
                            <TrashIcon width={15.42} height={18.74} strokeWidth={1} strokeColor="#C20000" />
                        </button>

                        <button
                            data-tip={isOnEdit ? 'cancel' : 'edit'}
                            data-for="default"
                            onClick={() => onEditClick(id, vacancy_type, template_type, isOnEdit)}
                        >
                            {isOnEdit ? (
                                <CrossIcon width={14} height={14} strokeWidth={1} stroke="#43927C" />
                            ) : (
                                <EditIcon />
                            )}
                        </button>
                    </div>
                </div>

                <div className={styles.templateBody}>
                    {description ? (
                        <p><b>Description: </b>{description}</p>
                    ) : (
                        <p><b>Salary description: </b>{salary_description}</p>
                    )}
                </div>

            </div>
        )
    }
)

export default VacancyManagerTemplatesListItem